"use client"

import { useEffect, useState } from 'react';

const LoadScript = ({ data = "" }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const loadScript = () => {
            if (!loaded) {
                const script = document.createElement('script');
                script.innerHTML = data;
                document.body.appendChild(script);
                setLoaded(true);
            }
        };

        window.addEventListener('scroll', loadScript, { once: true });
        window.addEventListener('mousemove', loadScript, { once: true });

        return () => {
            window.removeEventListener('scroll', loadScript);
            window.removeEventListener('mousemove', loadScript);
        };
    }, [loaded]);

    return null;
}

export const GoogleLayoutScript = () => {
    return (
        <LoadScript
            data={`(function(w,d,s,l,i){
                        w[l] = w[l] || [];
                        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
                        var f = d.getElementsByTagName(s)[0],
                            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                        j.async = true;
                        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                        f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', 'GTM-M9VBP7R');
                `}
        />
    )
};


export const GoogleAnalytics = () => {
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "G-EMDQH954PX");
        gtag("config", "AW-16834169127");
    }, []);

    return (
        <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-EMDQH954PX"
        ></script>
    );
};


export const FactorsScript = () => {
    return (
        <LoadScript
            data={`
                    window.faitracker = window.faitracker || function() { this.q = []; var t = new
                    CustomEvent("FAITRACKER_QUEUED_EVENT"); return this.init = function(t, e, a) {
                    this.TOKEN = t, this.INIT_PARAMS = e, this.INIT_CALLBACK = a, window.dispatchEvent(new
                    CustomEvent("FAITRACKER_INIT_EVENT")) }, this.call = function() { var e = { k:
                    "", a: [] }; if (arguments && arguments.length >= 1) { for (var a = 1; a
                    < arguments.length; a++) e.a.push(arguments[a]); e.k = arguments[0] } this.q.push(e),
                    window.dispatchEvent(t) }, this.message = function() { window.addEventListener("message",
                    function(t) { "faitracker" === t.data.origin && this.call("message", t.data.type, t.data.message) })
                    }, this.message(), this.init("ebzfqpcv5k6cn94ov2mik4rs41g7xeq6", { host: "https://api.factors.ai"
                    }), this }(), function() { var t = document.createElement("script"); t.type =
                    "text/javascript", t.src = "https://app.factors.ai/assets/factors.js", t.async = !0, (d =
                    document.getElementsByTagName("script")[0]).parentNode.insertBefore(t, d) }()
                `}
        />
    )
};

export const ClarityScript = () => {
    return (
        <LoadScript
            data={`
                (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "qq4fge66ja");
            `}
        />
    )
}

export const HireTalentScript = () => {
    useEffect(() => {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'conversion', {
                send_to: 'AW-16834169127/zLmzCMqvuZMaEKeSlNs-',
            });
        }
    }, []);

    return null;
};
